module.exports = __webpack_public_path__ + "img/babyhug.331b5dea.jpg";